import AreaContainer from "../AreaContainer";
import styles from './sustainability.module.css';
import globalStyles from '../result.module.css';
import dynamic from "next/dynamic";

const EPC = dynamic(() => import("../EPC"), {
    ssr: true,
});

interface Props {
    sustainability: any;
    epc: any;
    epc_information: any;
    breeam_rating: any;
    place_name: string
}

const Sustainability = ({sustainability, epc, epc_information, breeam_rating, place_name}: Props) => {
    if(!sustainability && !epc && !epc_information) return null;

    return <AreaContainer area="sustainability" style={null} extraClass={null}>
                <div className={styles.UpgradeWrapper}>
                    <h2 className={globalStyles.subTitleText}>Sustainability</h2>
                    {sustainability && (
                    <p className={`${globalStyles.preLine} ${globalStyles.mediumText} ${globalStyles.largeLineHeight} ${globalStyles.lightColorText}`}>{sustainability.value}</p>
                    )}
                    { Boolean(epc) && (
                        <>
                        <EPC epc={epc} area={place_name} />
                         {epc_information && (

                            <>
                                <h3 className={`${globalStyles.largeText} ${globalStyles.lightColorText}`}>{epc_information.label}</h3>
                                <p className={`${globalStyles.mediumText} ${globalStyles.largeLineHeight} ${globalStyles.lightColorText }`} >{epc_information.value}</p>
                            </>
                        )}
                        </>
                    )}
                    {
                        breeam_rating && (
                            <p className={`${globalStyles.mediumText} ${globalStyles.largeLineHeight} ${globalStyles.lightColorText }`} ><span>BREEAM Rating:</span> {breeam_rating.value}</p>
                        )
                    } 
                    {(epc_information && !Boolean(epc)) && (
                    <p className={`${globalStyles.preLine} ${globalStyles.mediumText} ${globalStyles.largeLineHeight} ${globalStyles.lightColorText}`}>{epc_information.value}</p>
                    )}
                </div>
            </AreaContainer>
};

export default Sustainability;